module.exports = __webpack_public_path__ + "img/texiao-_0000s_0008_9.1ec23313.png";